import script from "./SidebarItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=1cdb3e61&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdb3e61"]])

export default __exports__